/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  selectFieldTimePerform,
  selectFieldExecutorExecutionInterval,
  selectFieldExecutorExecutionIntervalCheck,
  selectFieldTypeId
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import {
  changeFieldTimePerform,
  changeFieldExecutorExecutionInterval,
  changeFieldExecutorExecutionIntervalCheck
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import {
  getItemFromRefList,
  getValueFromRefDataModules
} from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';
import DefaultSelect from '../../../Common/Inputs/DefaultSelect/DefaultSelect';

class ExecOptionsTaskInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /**
       * Параметры отвечают за disabled поля ExecutorExecutionInterval и меняеют его значение при изменении
       * */
      executor_execution_interval_toggle:
        this.props.fieldExecutorExecutionInterval.value !== null ? '1' : '0',
      executor_execution_interval_toggle_items: [
        {
          value: '0',
          title: t('Одноразовое задание')
        },
        {
          value: '1',
          title: t('Многоразовое задание')
        }
      ],
      executor_execution_interval_check_items: [
        {
          value: '0',
          title: t('Запретить новые выполнения, пока не проверено текущее')
        },
        {
          value: '1',
          title: t('Разрешить новые выполнения, не дожидаться проверки')
        }
      ]
    };
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    $(`#collapseConfines_try`).collapse('show');
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.executor_execution_interval_toggle !==
      this.state.executor_execution_interval_toggle
    ) {
      if (this.state.executor_execution_interval_toggle === '0') {
        this.props.changeFieldExecutorExecutionInterval(null);
      } else {
        this.props.changeFieldExecutorExecutionInterval('0');
      }
    }
  }

  render() {
    let maxTimeCheckingMinutes;
    if (this.props.fieldTypeId.value) {
      const found = this.props.taskTypes.find(
        item =>
          item.value.toString() === this.props.fieldTypeId.value.toString()
      );
      if (found) {
        maxTimeCheckingMinutes = parseInt(found.max_time_checking_minutes, 10);
      }
    }
    return (
      <React.Fragment>
        <div
          aria-multiselectable="true"
          className="panel-group"
          id="panelGroupTry"
          role="tablist"
        >
          <section className="panel panel-default panel-heading_padding-large panel-body_bg-sub">
            <div className="panel-heading" role="tab">
              <h2 className="panel-title">
                <a
                  aria-controls="filter-collapseConfines_try"
                  aria-expanded="true"
                  className="dropdown-toggle dropdown-toggle-collapse collapsed"
                  data-toggle="collapse"
                  href="#collapseConfines_try"
                  role="button"
                >
                  <i className="fa fa-play-circle-o fa-fw" />{' '}
                  {t('Выполнение – ограничения, лимиты')}
                </a>
              </h2>
            </div>
            <div
              aria-labelledby="headingOne"
              className="panel-collapse collapse"
              id="collapseConfines_try"
              role="tabpanel"
              aria-expanded="true"
            >
              <div className="panel-body">
                <div className="row">
                  <div className="col-xs-24 col-sm-12 col-md-12">
                    <div className="form-group">
                      <label
                        className="control-label"
                        htmlFor="Confines_try_timeDo"
                      >
                        {t('Время на выполнение')}
                      </label>
                      <DefaultSelect
                        selectTitleNullValue={null}
                        selectArrItems={Object.keys(
                          this.props.taskIntervalExecution
                        )
                          .map(key => ({
                            value: key,
                            title: this.props.taskIntervalExecution[key]
                          }))
                          .filter(item => {
                            const valueInt = parseInt(item.value, 10);
                            if (maxTimeCheckingMinutes) {
                              // return valueInt <= maxTimeCheckingMinutes;
                            }
                            return valueInt <= 4320;
                          })}
                        value={this.props.fieldTimePerform.value}
                        handleChangeValue={value => {
                          this.props.changeFieldTimePerform(value);
                        }}
                      />
                      <small className="help-block">
                        {t(
                          'Время, которое отводится пользователю для выполнения задания. Если он не уложится в срок, его заявка удалится, а зарезервированные средства вернутся на баланс задания.'
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-xs-24 col-sm-12 col-md-12">
                    <div className="form-group">
                      <label
                        className="control-label"
                        htmlFor="Confines_try_multy"
                      >
                        {t('Многоразовость выполнения для 1 пользователя')}
                      </label>
                      <DefaultSelect
                        selectTitleNullValue={null}
                        selectArrItems={
                          this.state.executor_execution_interval_toggle_items
                        }
                        value={this.state.executor_execution_interval_toggle}
                        handleChangeValue={value => {
                          this.setState({
                            executor_execution_interval_toggle: value
                          });
                        }}
                      />
                      <small className="help-block">
                        {t(
                          'Установив эту опцию, вы сделаете своё задание <strong>многоразовым</strong>.<br /> Это значит, что один и тот же пользователь сможет выполнять ваше задание повторно.'
                        )}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-24 col-sm-12 col-md-12">
                    <div className="form-group">
                      <label
                        className="control-label"
                        htmlFor="Confines_try_rep"
                      >
                        {t('Можно повторно выполнять задание каждые')}
                      </label>
                      <DefaultSelect
                        selectTitleNullValue={
                          this.state.executor_execution_interval_toggle === '0'
                            ? t('Не выбрано')
                            : null
                        }
                        hasDisabled={
                          this.state.executor_execution_interval_toggle === '0'
                        }
                        selectArrItems={Object.keys(
                          this.props.taskIntervalExecutorExecution
                        ).map(key => ({
                          value: key,
                          title: this.props.taskIntervalExecutorExecution[key]
                        }))}
                        value={this.props.fieldExecutorExecutionInterval.value}
                        handleChangeValue={value => {
                          this.props.changeFieldExecutorExecutionInterval(
                            value
                          );
                        }}
                      />
                      <small className="help-block">
                        {t(
                          'Время, спустя которое один и тот же пользователь сможет выполнять ваше задание снова'
                        )}
                        .
                      </small>
                    </div>
                  </div>
                  <div className="col-xs-24 col-sm-12 col-md-12">
                    <div className="form-group">
                      <label
                        className="control-label"
                        htmlFor="Confines_try_check"
                      >
                        {t('Выполнение до проверки')}
                      </label>
                      <DefaultSelect
                        selectTitleNullValue={null}
                        hasDisabled={
                          this.state.executor_execution_interval_toggle === '0'
                        }
                        selectArrItems={
                          this.state.executor_execution_interval_check_items
                        }
                        value={
                          this.props.fieldExecutorExecutionIntervalCheck.value
                        }
                        handleChangeValue={value => {
                          this.props.changeFieldExecutorExecutionIntervalCheck(
                            value
                          );
                        }}
                      />
                      <small className="help-block">
                        {t(
                          'Установив эту опцию, вы разрешите одному и томуже пользователю выполнять ваше задание снова, не дожидаясь вашей проверки его предыдущих выполнений'
                        )}
                        .
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

ExecOptionsTaskInputs.propTypes = {
  fieldTimePerform: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldExecutorExecutionInterval: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldExecutorExecutionIntervalCheck: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  changeFieldTimePerform: PropTypes.func.isRequired,
  changeFieldExecutorExecutionInterval: PropTypes.func.isRequired,
  changeFieldExecutorExecutionIntervalCheck: PropTypes.func.isRequired,
  taskIntervalExecution: PropTypes.shape({}).isRequired,
  taskIntervalExecutorExecution: PropTypes.shape({}).isRequired,
  taskTypes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  fieldTypeId: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  fieldTimePerform: selectFieldTimePerform(state, props.reducerName),
  fieldExecutorExecutionInterval: selectFieldExecutorExecutionInterval(
    state,
    props.reducerName
  ),
  fieldExecutorExecutionIntervalCheck: selectFieldExecutorExecutionIntervalCheck(
    state,
    props.reducerName
  ),
  taskIntervalExecution: getItemFromRefList(state, 'taskIntervalExecution'),
  taskIntervalExecutorExecution: getItemFromRefList(
    state,
    'taskIntervalExecutorExecution'
  ),
  taskTypes: getValueFromRefDataModules(state, 'tasks.taskTypes'),
  fieldTypeId: selectFieldTypeId(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldTimePerform: value =>
    dispatch(changeFieldTimePerform(props.reducerName, value)),
  changeFieldExecutorExecutionInterval: value =>
    dispatch(changeFieldExecutorExecutionInterval(props.reducerName, value)),
  changeFieldExecutorExecutionIntervalCheck: value =>
    dispatch(
      changeFieldExecutorExecutionIntervalCheck(props.reducerName, value)
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExecOptionsTaskInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/ExecOptionsTaskInputs/ExecOptionsTaskInputs.js